if (!customElements.get('contact-form')) {
  customElements.define(
    'contact-form',
    class contactForm extends HTMLElement {
      constructor() {
        super();

        this.submitted = false;

        this.buttons = this.querySelectorAll('.button-large');

        this.createHubspotFormTo('contact-us-page-form');
        this.createHubspotFormTo('contact-us-page-form-mobile');
      }

      isSubmitted() {
        this.buttons.forEach((btn) => {
          btn.classList.remove('hidden');
        });
      }

      createHubspotFormTo(id) {
        if (!!id && !!window && window['hbspt']) {
          const hubspot = window['hbspt'];

          const config = {
            region: 'na1',
            portalId: '7810140',
            formId: '579252b8-e534-4573-8a5c-bf825525012c',
            target: `#${id}`,
          };

          hubspot.forms.create(config);

          const interval = setInterval(() => {
            const container = document.getElementById(id);
            if (!container) return;
            const form = container.children.item(0);

            if (!!form) {
              const children = [];

              for (let i = 0; i < 5; i++) {
                const element = form.children.item(i);
                if (!element) continue;
                const innerGroup = element.children.item(2);
                if (!innerGroup) continue;
                const input = innerGroup.children.item(0);
                if (!input) continue;

                children.push({
                  node: element,
                  input: input,
                });
              }

              children.forEach(({node, input}) => {
                input.addEventListener('focus', () => {
                  node.classList.add('focused');
                });

                input.addEventListener('blur', () => {
                  if (!input.value) {
                    node.classList.remove('focused');
                  }
                });
              });

              form.addEventListener('hsvalidatedsubmit', () => {
                setTimeout(() => {
                  this.isSubmitted();
                }, 500);
              });

              clearInterval(interval);
            }
          }, 1000);
        }
      }
    },
  );
}
